import { Link } from "react-router-dom";
import { categories } from "@/mocks/anime";

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6">
          <span className="text-xs font-medium text-secondary-700">主题分类</span>
          <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">
            想追哪一类？来这里找
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            从热血到日常，分类清晰，快速定位你爱的作品。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((cat) => (
            <Link
              key={cat.name}
              to={`/series?cat=${encodeURIComponent(cat.name)}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-secondary-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-bold text-foreground-950">{cat.name}</p>
                <p className="text-xs text-foreground-600">{cat.count} 部连载中</p>
              </div>
              <i className="ri-arrow-right-s-line ml-auto text-lg text-foreground-400 group-hover:text-secondary-600"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}